<!--线下面单服务商-->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <h3 style="padding-left:15px; ">线下建单711和全家服务商和LINE</h3>
      <el-row v-for="(volumn, idx) in form.volumns" :key="idx">
        <el-col :xs="12" :sm="12" :md="18" style="padding:15px;">
          <el-form-item :label="msg('服务商：')">
            <el-input v-model="volumn.sender" :placeholder="msg('请输入服务商名称')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="18" style="padding:15px;">
          <el-form-item :label="msg('LINE：')">
            <el-input v-model="volumn.line" :placeholder="msg('请输入LINE，如：@yip3025t')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingPageSender",
  data() {
    return {
      xgroup: 'PAGE_SENDER',  //服务商
      form: {
        volumns: [],
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.volumns = [];

      let volumns = data; //材积计算
      //材积计算
      if (volumns.length > 0) {
        volumns.forEach(a => {
          if (a.xvalue) {
            let ws = JSON.parse(a.xvalue);
            let sender = ws.sender;
            let line = ws.line;
            let warn = {
              id: a.id,
              sender: sender,
              line: line,
              owner: a.owner,
            }
            _this.form.volumns.push(warn);
          }
        })
      } else {
        _this.form.volumns.push({
          id: null,
          xkey: 'PAGE_SENDER',
          owner: null,
          xgroup: 'PAGE_SENDER',
          sender: '',
          line: '',
          xtype: 1
        })
      }
    },
    update() {
      let datas = [];
      //构建材积计算
      let volumn = this.form.volumns[0];
      let key = this.xgroup;

      let sender = volumn.sender;
      let line = volumn.line;

      // if(!sender || !line){
      //     this.$message(this.msg('请输入服务商和LINE'));
      //     return;
      // }

      datas.push({
        id: volumn.id,
        xkey: key,
        owner: volumn.owner ? volumn.owner : null,
        xgroup: key,
        xvalue: JSON.stringify({
          sender: sender,
          line: line,
        }),
      });

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>